var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", [
    _c(
      "section",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.dadosDeCobranca.PossuiCobrancas,
            expression: "!dadosDeCobranca.PossuiCobrancas"
          }
        ],
        staticClass: "mensagem_aviso-beneficiario u-margem-inferior-mini",
        attrs: { tabindex: "1" }
      },
      [
        _c("mensagem-de-aviso", {
          attrs: {
            mensagem: "Não existem parcelas disponíveis para pagamento.",
            tipoDeMensagem: "sucesso"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.possuiParcelasEmAtraso &
              !_vm.dadosDeCobranca.ParticipaDoMorarLegal,
            expression:
              "possuiParcelasEmAtraso & !dadosDeCobranca.ParticipaDoMorarLegal"
          }
        ],
        staticClass: "mensagem_aviso-beneficiario u-margem-inferior-mini"
      },
      [
        _c("mensagem-de-aviso", {
          attrs: {
            mensagem:
              "Suas parcelas estão em atraso, selecione as parcelas abaixo e clique em\n                    emitir boleto para pagamento.\n                    Caso necessite de uma renegociação procure um de nossos postos de atendimento.",
            tipoDeMensagem: "erro"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.possuiParcelasEmAtraso &
              _vm.dadosDeCobranca.ParticipaDoMorarLegal,
            expression:
              "possuiParcelasEmAtraso & dadosDeCobranca.ParticipaDoMorarLegal"
          }
        ],
        staticClass: "mensagem_aviso-beneficiario u-margem-inferior-mini"
      },
      [
        _c("mensagem-de-aviso", {
          attrs: {
            mensagem:
              " Ganhe 60% de desconto nos juros e multas pagando no mínimo 4 parcelas em atraso ou ganhe 100% de desconto nos juros e multas para quitar todas as parcelas em atraso.\n                    Descontos previstos na Lei Nº 6.253, de 27 de maio de 2024 e suas alterações da campanha Morar Legal.",
            tipoDeMensagem: "erro"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.dadosDeCobranca.FinanciamentoEhReurbE,
            expression: "dadosDeCobranca.FinanciamentoEhReurbE"
          }
        ],
        staticClass: "mensagem_aviso-beneficiario u-margem-inferior-mini"
      },
      [
        _c("mensagem-de-aviso", {
          attrs: {
            mensagem:
              "A seleção de parcelas só é permitida na ordem das mais antigas para as mais recentes",
            tipoDeMensagem: "atencao"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.dadosDeCobranca.FinanciamentoEstaBloqueado,
            expression: "dadosDeCobranca.FinanciamentoEstaBloqueado"
          }
        ],
        staticClass:
          "mensagem_aviso-beneficiario mensagem_cor-aviso u-margem-inferior-grande"
      },
      [
        _c("header", [
          _c("i", {
            staticClass:
              "far fa-lock-alt fa-2x u-margem-direita-mini fa_cor-erro"
          }),
          _vm._v(" "),
          _vm.dadosDeCobranca.FinanciamentoEstaBloqueadoPorNotificacaoJudicial
            ? _c("strong", [
                _vm._v(
                  "\n                VOCÊ POSSUI PARCELAS BLOQUEADAS POR " +
                    _vm._s(_vm.dadosDeCobranca.TipoDeBloqueio) +
                    "\n            "
                )
              ])
            : _c("strong", [
                _vm._v(
                  "\n                SEU FINANCIAMENTO ESTÁ BLOQUEADO POR " +
                    _vm._s(_vm.dadosDeCobranca.TipoDeBloqueio) +
                    "\n            "
                )
              ])
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            Estas parcelas só podem ser pagas após desbloqueio e resolução do problema comunicado.\n        "
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "nav",
      [
        _c("div", { staticClass: "boletos" }, [
          _vm.dadosDeCobranca.CobrancasSelecionaveis.length > 0
            ? _c(
                "label",
                {
                  staticClass:
                    "formulario__input-checkbox u-margem-superior-grande"
                },
                [
                  _c("input", {
                    attrs: {
                      type: "checkbox",
                      tabindex: "1",
                      disabled:
                        _vm.dadosDeCobranca
                          .PossuiDivergenciaDeRegraDePrimeiraParcela
                    },
                    on: { input: _vm.selecionarTodasAsParcelas }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "formulario__marcador",
                    class: !_vm.dadosDeCobranca
                      .PossuiDivergenciaDeRegraDePrimeiraParcela
                      ? ""
                      : "formulario_input-desabilitado"
                  }),
                  _vm._v(" "),
                  _c("h3", { staticClass: "titulo titulo_medio" }, [
                    _vm._v(
                      " Selecionar todas as " +
                        _vm._s(
                          _vm.dadosDeCobranca.CobrancasSelecionaveis.length
                        ) +
                        " parcelas disponíveis"
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.cobrancasVincendas.length > 0,
                  expression: "cobrancasVincendas.length > 0"
                }
              ]
            },
            [
              _c(
                "h4",
                {
                  staticClass: "titulo titulo_pequeno u-margem-esquerda-pequena"
                },
                [_vm._v("Parcelas vincendas")]
              ),
              _vm._v(" "),
              _c("lista-de-cobrancas", {
                attrs: {
                  cobrancas: _vm.cobrancasVincendas,
                  prazo: _vm.dadosDeCobranca.Prazo,
                  financiamentoEhReurbE:
                    _vm.dadosDeCobranca.FinanciamentoEhReurbE,
                  podeSelecionarParcelas: true,
                  selecionarTodasAsParcelas: _vm.todasAsParcelasSelecionadas,
                  possuiDivergenciaDeRegraDePrimeiraParcela:
                    _vm.dadosDeCobranca
                      .PossuiDivergenciaDeRegraDePrimeiraParcela
                },
                on: {
                  marcarProximaParcelaSelecionavel:
                    _vm.controlarParcelasSelecionaveis,
                  obterProximoNumeroDeParcelaNaOrdem:
                    _vm.obterProximoNumeroDeParcelaNaOrdem
                },
                model: {
                  value: _vm.parcelasVincendasSelecionadas,
                  callback: function($$v) {
                    _vm.parcelasVincendasSelecionadas = $$v
                  },
                  expression: "parcelasVincendasSelecionadas"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.cobrancasVencidas.length > 0,
                  expression: "cobrancasVencidas.length > 0"
                }
              ]
            },
            [
              _c(
                "h3",
                { staticClass: "titulo titulo_medio u-padding-inferior-media" },
                [_vm._v("Parcelas vencidas")]
              ),
              _vm._v(" "),
              _c(
                "section",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.dadosDeCobranca.FinanciamentoEhReurbE,
                      expression: "!dadosDeCobranca.FinanciamentoEhReurbE"
                    }
                  ],
                  staticClass:
                    "mensagem_aviso-beneficiario u-margem-inferior-mini"
                },
                [
                  _c("mensagem-de-aviso", {
                    attrs: {
                      mensagem:
                        "A seleção de parcelas inadimplentes só é permitida na ordem das mais antigas para as mais recentes",
                      tipoDeMensagem: "atencao"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("lista-de-cobrancas", {
                attrs: {
                  cobrancas: _vm.cobrancasVencidas,
                  prazo: _vm.dadosDeCobranca.Prazo,
                  financiamentoEhReurbE:
                    _vm.dadosDeCobranca.FinanciamentoEhReurbE,
                  podeSelecionarParcelas: true,
                  selecionarTodasAsParcelas: _vm.todasAsParcelasSelecionadas,
                  possuiDivergenciaDeRegraDePrimeiraParcela:
                    _vm.dadosDeCobranca
                      .PossuiDivergenciaDeRegraDePrimeiraParcela
                },
                on: {
                  marcarProximaParcelaSelecionavel:
                    _vm.controlarParcelasSelecionaveis,
                  obterProximoNumeroDeParcelaNaOrdem:
                    _vm.obterProximoNumeroDeParcelaNaOrdem
                },
                model: {
                  value: _vm.parcelasVencidasSelecionadas,
                  callback: function($$v) {
                    _vm.parcelasVencidasSelecionadas = $$v
                  },
                  expression: "parcelasVencidasSelecionadas"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.dadosDeCobranca.CobrancasBloqueadas.length > 0,
                  expression: "dadosDeCobranca.CobrancasBloqueadas.length > 0"
                }
              ]
            },
            [
              _c(
                "h4",
                {
                  staticClass: "titulo titulo_pequeno u-margem-esquerda-pequena"
                },
                [_vm._v("Parcelas bloqueadas")]
              ),
              _vm._v(" "),
              _c("lista-de-cobrancas", {
                attrs: {
                  cobrancas: _vm.dadosDeCobranca.CobrancasBloqueadas,
                  prazo: _vm.dadosDeCobranca.Prazo,
                  podeSelecionarParcelas: false,
                  financiamentoEstaBloqueado:
                    _vm.dadosDeCobranca.FinanciamentoEstaBloqueado,
                  selecionarTodasAsParcelas: false,
                  possuiDivergenciaDeRegraDePrimeiraParcela:
                    _vm.dadosDeCobranca
                      .PossuiDivergenciaDeRegraDePrimeiraParcela
                },
                on: {
                  marcarProximaParcelaSelecionavel:
                    _vm.controlarParcelasSelecionaveis,
                  obterProximoNumeroDeParcelaNaOrdem:
                    _vm.obterProximoNumeroDeParcelaNaOrdem
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("resumo-das-parcelas", {
          attrs: {
            parcelasSelecionadas: _vm.parcelasSelecionadas,
            dadosDeNovacao: _vm.dadosDeNovacao,
            totalDeParcelasAtrasadas: _vm.totalDeParcelasAtrasadas,
            participaDoMorarLegal: _vm.dadosDeCobranca.ParticipaDoMorarLegal
          },
          on: {
            controlaSobreposicao: function($event) {
              _vm.mostrarSobreposicao = !_vm.mostrarSobreposicao
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "sobreposicao",
      class: _vm.mostrarSobreposicao ? "sobreposicao_ativo" : ""
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03c97590", { render: render, staticRenderFns: staticRenderFns })
  }
}